import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/admin/Dashboard";
import Sidebar from "../components/admin/Sidebar";
import "../styles/adminCDN.css";
import "../styles/admin.css";
import AdminFooter from "../components/admin/AdminFooter";
import CategoryGroups from "../pages/admin/CategoryGroups/CategoryGroups";
import CategoryGroupAdd from "../pages/admin/CategoryGroups/CategoryGroupAdd";
import CategoryGroupEdit from "../pages/admin/CategoryGroups/CategoryGroupEdit";
import CategoryGroupView from "../pages/admin/CategoryGroups/CategoryGroupView";
import Banner from "../pages/admin/Banner/Banner";
import BannerAdd from "../pages/admin/Banner/BannerAdd";
import BannerEdit from "../pages/admin/Banner/BannerEdit";
import BannerView from "../pages/admin/Banner/BannerView";
import Slider from "../pages/admin/Slider/Slider";
import SliderAdd from "../pages/admin/Slider/SliderAdd";
import SliderEdit from "../pages/admin/Slider/SliderEdit";
import SliderView from "../pages/admin/Slider/SliderView";
import CategoriesIndex from "../pages/admin/categories/CategoriesIndex";
import CategoriesAdd from "../pages/admin/categories/CategoriesAdd";
import CategoriesView from "../pages/admin/categories/CategoriesView";
import CategoriesEdits from "../pages/admin/categories/CategoriesEdits";
import AdminHeader from "../components/admin/AdminHeader";
import Products from "../pages/admin/Product/Products";
import ProductsAdd from "../pages/admin/Product/ProductsAdd";
import ProductsEdit from "../pages/admin/Product/ProductsEdit";
import ProductsView from "../pages/admin/Product/ProductsView";
import Shop from "../pages/admin/Shop/Shop";
import ShopView from "../pages/admin/Shop/ShopView";
import Stores from "../pages/admin/Shop/Stores";
import Locations from "../pages/admin/Shop/Locations";
import DealCategory from "../pages/admin/DealCategory/DealCategory";
import DealCategoryAdd from "../pages/admin/DealCategory/DealCategoryAdd";
import DealCategoryEdit from "../pages/admin/DealCategory/DealCategoryEdit";
import DealCategoryView from "../pages/admin/DealCategory/DealCategoryView";
import ScrollToTop from "../pages/ScrollToTop";
import User from "../pages/admin/User/User";
import UserView from "../pages/admin/User/UserView";
import Orders from "../pages/admin/Order/Orders";
import OrderView from "../pages/admin/Order/OrderView";
import Referrer from "../pages/admin/Referrer/Referrer";
import ReferrerAdd from "../pages/admin/Referrer/ReferrerAdd";
import ReferrerEdit from "../pages/admin/Referrer/ReferrerEdit";
import ReferrerDeatils from "../pages/admin/ReferrerDetails/ReferrerDetails";
import ProductOrder from "../pages/admin/Product/ProductOrder";
import SubCategoriesIndex from "../pages/admin/SubCategory/SubCategoriesIndex";
import SubCategoriesAdd from "../pages/admin/SubCategory/SubCategoriesAdd";
import SubCategoriesView from "../pages/admin/SubCategory/SubCategoriesView";
import SubCategoriesEdit from "../pages/admin/SubCategory/SubCategoriesEdit";
import TopDeal from "../pages/admin/Product/TopDeal";
import Campaign from "../pages/admin/Campaign/Campaign";
import CampaignAdd from "../pages/admin/Campaign/CampaignAdd";
import CampaignEdit from "../pages/admin/Campaign/CampaignEdit";
import CampaignView from "../pages/admin/Campaign/CampaignView";
import CampaignSubmission from "../pages/admin/CampaignSubmission/CampaignSubmission";
import CampaignSubmissionView from "../pages/admin/CampaignSubmission/CampaignSubmissionView";
import LeadMagnet from "../pages/admin/LeadMagnets/LeadMagnet";
import LeadMagnetEdit from "../pages/admin/LeadMagnets/LeadMagnetEdit";
import Voucher from "../pages/admin/Voucher/Voucher";
import VoucherAdd from "../pages/admin/Voucher/VoucherAdd";
import VoucherEdit from "../pages/admin/Voucher/VoucherEdit";
import VoucherView from "../pages/admin/Voucher/VoucherView";
import FreeCash from "../pages/admin/FreeCash/FreeCash";
import FreeCashAdd from "../pages/admin/FreeCash/FreeCashAdd";
import FreeCashEdit from "../pages/admin/FreeCash/FreeCashEdit";
import FreeCashView from "../pages/admin/FreeCash/FreeCashView";
import UserWallets from "../pages/admin/UserWallets/UserWallets";
import UserWalletsView from "../pages/admin/UserWallets/UserWalletsView.js";
import Affiliate from "../pages/admin/Affiliate/Affiliate.js";
import AffiliateAdd from "../pages/admin/Affiliate/AffiliateAdd.js";
import AffiliateEdit from "../pages/admin/Affiliate/AffiliateEdit.js";
import AffiliateView from "../pages/admin/Affiliate/AffiliateView.js";
import AffiliatePayout from "../pages/admin/AffiliatePayout/AffiliatePayout.js";
import AffiliatePayoutAdd from "../pages/admin/AffiliatePayout/AffiliatePayoutAdd.js";
import AffiliatePayoutEdit from "../pages/admin/AffiliatePayout/AffiliatePayoutEdit.js";
import AffiliatePayoutView from "../pages/admin/AffiliatePayout/AffiliatePayoutView.js";

function Admin({ handleLogout }) {
  return (
    <div>
      <BrowserRouter basename="/dealsmachiVendor">
        <ScrollToTop />
        <div className="d-flex flex-column flex-lg-row bg-surface-secondary ">
          <Sidebar handleLogout={handleLogout} />

          <div className="flex-grow-1 h-screen overflow-y-lg-auto">
            <AdminHeader />
            <main className="pt-2" style={{ backgroundColor: "#f2f2f2" }}>
              <div style={{ minHeight: "90vh" }}>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="*" element={<Dashboard />} />

                  {/* Category Groups */}
                  <Route path="/categorygroup" element={<CategoryGroups />} />
                  <Route
                    path="/categorygroup/add"
                    element={<CategoryGroupAdd />}
                  />
                  <Route
                    path="/categorygroup/edit/:id"
                    element={<CategoryGroupEdit />}
                  />
                  <Route
                    path="/categorygroup/view/:id"
                    element={<CategoryGroupView />}
                  />

                  {/* Categories */}
                  <Route path="/categories" element={<CategoriesIndex />} />
                  <Route path="/categories/add" element={<CategoriesAdd />} />
                  <Route
                    path="/categories/view/:id"
                    element={<CategoriesView />}
                  />
                  <Route
                    path="/categories/edit/:id"
                    element={<CategoriesEdits />}
                  />

                  {/* SubCategories */}
                  <Route
                    path="/subcategories"
                    element={<SubCategoriesIndex />}
                  />
                  <Route
                    path="/subcategories/add"
                    element={<SubCategoriesAdd />}
                  />
                  <Route
                    path="/subcategories/view/:id"
                    element={<SubCategoriesView />}
                  />
                  <Route
                    path="/subcategories/edit/:id"
                    element={<SubCategoriesEdit />}
                  />

                  {/* {/ Banner /} */}
                  <Route path="/banner" element={<Banner />} />
                  <Route path="/banner/add" element={<BannerAdd />} />
                  <Route path="/banner/edit" element={<BannerEdit />} />
                  <Route path="/banner/view" element={<BannerView />} />

                  <Route path="/dealcategories" element={<DealCategory />} />
                  <Route
                    path="/dealcategories/add"
                    element={<DealCategoryAdd />}
                  />
                  <Route
                    path="/dealcategories/edit/:id"
                    element={<DealCategoryEdit />}
                  />
                  <Route
                    path="/dealcategories/view/:id"
                    element={<DealCategoryView />}
                  />

                  {/* {/ Slider /} */}
                  <Route path="/slider" element={<Slider />} />
                  <Route path="/slider/add" element={<SliderAdd />} />
                  <Route path="/slider/edit/:id" element={<SliderEdit />} />
                  <Route path="/slider/view/:id" element={<SliderView />} />

                  {/* {/ Slider /} */}
                  <Route path="/user" element={<User />} />
                  <Route path="/user/view/:id" element={<UserView />} />

                  {/* {/ Slider /} */}
                  <Route path="/order" element={<Orders />} />
                  <Route
                    path="/order/view/:order_id/:product_id"
                    element={<OrderView />}
                  />

                  {/* {/ Product /} */}
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/add" element={<ProductsAdd />} />
                  <Route path="/products/edit" element={<ProductsEdit />} />
                  <Route path="/products/view/:id" element={<ProductsView />} />
                  <Route path="/products/order" element={<ProductOrder />} />
                  <Route path="/products/topdeal" element={<TopDeal />} />

                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/view/:id" element={<ShopView />} />
                  <Route path="/stores" element={<Stores />} />
                  <Route path="/locations" element={<Locations />} />

                  {/* Referral Amount */}
                  <Route path="/referrer" element={<Referrer />} />
                  <Route path="/referrer/add" element={<ReferrerAdd />} />
                  <Route path="/referrer/edit/:id" element={<ReferrerEdit />} />

                  <Route path="/freeCash" element={<FreeCash />} />
                  <Route path="/freeCash/add" element={<FreeCashAdd />} />
                  <Route path="/freeCash/edit/:id" element={<FreeCashEdit />} />
                  <Route path="/freeCash/view/:id" element={<FreeCashView />} />

                  {/* User Wallets */}
                  <Route path="/user-wallets" element={<UserWallets />} />
                  <Route
                    path="/user-wallets/view/:id"
                    element={<UserWalletsView />}
                  />

                  {/* {/ Lead Magnets /} */}
                  <Route path="/leadmagnet" element={<LeadMagnet />} />
                  <Route path="/leadmagnet/edit" element={<LeadMagnetEdit />} />

                  {/* {/ Campaign /} */}
                  <Route path="/campaign" element={<Campaign />} />
                  <Route path="/campaign/add" element={<CampaignAdd />} />
                  <Route path="/campaign/edit/:id" element={<CampaignEdit />} />
                  <Route path="/campaign/view/:id" element={<CampaignView />} />

                  {/* {/ Campaign Submission /} */}
                  <Route
                    path="/campaignsubmission"
                    element={<CampaignSubmission />}
                  />
                  <Route
                    path="/campaignsubmission/view/:id"
                    element={<CampaignSubmissionView />}
                  />

                  {/* {/ Voucher /} */}
                  <Route path="/voucher" element={<Voucher />} />
                  <Route path="/voucher/add" element={<VoucherAdd />} />
                  <Route path="/voucher/edit/:id" element={<VoucherEdit />} />
                  <Route path="/voucher/view/:id" element={<VoucherView />} />
                  
                  {/* {/ Affiliate /} */}
                  <Route path="/affiliate" element={<Affiliate />} />
                  <Route path="/affiliate/add" element={<AffiliateAdd />} />
                  <Route path="/affiliate/edit/:id" element={<AffiliateEdit />} />
                  <Route path="/affiliate/view/:id" element={<AffiliateView />} />

                  {/* {/ AffiliatePayout /} */}
                  <Route path="/affiliate-payout" element={<AffiliatePayout />} />
                  <Route path="/affiliate-payout/add" element={<AffiliatePayoutAdd />} />
                  <Route path="/affiliate-payout/edit/:id" element={<AffiliatePayoutEdit />} />
                  <Route path="/affiliate-payout/view/:id" element={<AffiliatePayoutView />} />

                  {/* Referrer */}
                  <Route
                    path="/referrer_vendor"
                    element={<ReferrerDeatils />}
                  />
                </Routes>
              </div>
              <AdminFooter />
            </main>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default Admin;
